import { CogIcon, Modal, ModalContent } from './LoaderWithPageOverlayStyle';
import { pageLoaderState } from '../../constants/loader';
import { useEffect, useState } from 'react';

function LoaderWithPageOverlay() {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    // Inject CSS if not already present
    if (!document.querySelector('#page-loader-styles')) {
      const style = document.createElement('style');
      style.id = 'page-loader-styles';
      style.textContent = `
        body.page-loader-visible {
          overflow: hidden;
        }
      `;
      document.head.appendChild(style);
    }
    
    document.body.classList.toggle('page-loader-visible', open);
  }, [open]);

  useEffect(() => {
    const subscription = pageLoaderState.subscribe((value) => {
      setOpen(value.size > 0);
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <Modal open={open}>
      <ModalContent>
        <CogIcon />
      </ModalContent>
    </Modal>
  );
}

export default LoaderWithPageOverlay;
